import {useParams} from "react-router-dom";
import Profile from "../components/User/Profile";

export default function User() {    
    const {username} = useParams();
    console.log(username+"desde user");
    return (
        <>
            <Profile username={username} />
        </>
    );
}
